module.exports = __webpack_public_path__ + "img/icon_sportMenu_billiard.ab784cbe.svg";